
import AreaContainer from "../AreaContainer";
import { useFeatures } from "../hooks/useFeatures";
import styles from './schemeSpec.module.css';
import globalStyles from '../result.module.css';
interface Props {
    features: any
}
interface Row {
    title: string,
    value: string
}

type features = {
    title: string,
    value: string | number
}

const SchemeSpec = ({ features }: Props) => {
    const data: features[] = useFeatures([
        'cctv',
        '24hr_access',
        '24hr_security',
        'air_conditioning',
        'communal_reception',
        'car_parking',
        'cycle_racks',
        'flexible_accommodation',
        'goods_lift',
        'gym',
        'hgv_parking',
        'loading_bay',
        'loading_doors',
        'loading_lights',
        'manned_reception',
        'new_build',
        'nursery',
        'onsite_security',
        'passenger_lift',
        'petrol_filling_station',
        'raised_floor',
        'restaurant_cafe',
        'revolving_door',
        'secure_yard',
        'shower_changing_facilities',
        'sprinkler',
        'standby_generator',
        'suspended_ceilings',
        'swimming_pool'
    ], features);

    if (data && data.length == 0) return null;

    return <AreaContainer area="scheme-spec" style={null} extraClass={null}>
        <div className={styles.InfomationWrapper}>
            <h2 className={globalStyles.subTitleText}>Scheme Specification</h2>
            <ul>
                {data.map((d) => {
                    if (d.value)
                        return <li key={d.title} className={`${globalStyles.mediumText}  ${globalStyles.lightColorText}`}>{d.title}</li>
                })}

            </ul>
        </div>
    </AreaContainer>
};

export default SchemeSpec;
